export interface OrderListParams {
    search: string | undefined;
    page: number;
    page_size?: number;
    hide_draft_orders?: boolean;
    customer_status?: string;
    created_time_min?: string;
    created_time_max?: string;
    required_ship_date_min?: string;
    required_ship_date_max?: string;
    ordering?: string;
}

export const normalizeDateRange = (min?: string, max?: string): [string, string] | undefined => {
    if (!min || !max) {
        return undefined;
    }

    return [min, max];
};

export const buildOrderListParams = ({
    search,
    page,
    pageSize,
    status,
    createdDates,
    shipDates,
    sorter,
}: {
    search?: string;
    page: number;
    pageSize?: number;
    status?: string;
    createdDates?: [string, string];
    shipDates?: [string, string];
    sorter?: { field?: string; order?: string };
}): OrderListParams => {
    const params: OrderListParams = {
        search,
        page,
        page_size: pageSize,
        hide_draft_orders: true,
    };

    if (status) params.customer_status = status;
    if (createdDates) {
        params.created_time_min = createdDates[0];
        params.created_time_max = createdDates[1];
    }
    if (shipDates) {
        params.required_ship_date_min = shipDates[0];
        params.required_ship_date_max = shipDates[1];
    }
    if (sorter?.field) {
        params.ordering = `${sorter?.order === 'ascend' ? '' : '-'}${sorter.field}`;
    }

    return params;
};

export const shouldSkipOrderRowNavigation = (target: HTMLElement | null): boolean => {
    if (!target) {
        return false;
    }

    return !!target.closest('a, button, [role="button"], .ant-dropdown-trigger, .ant-dropdown-menu');
};
